/*
 *  Author: DL
 *  Date: 2020-12-06 14:56:03
 *  Email: dunaliang@fengmap.com
 *  LastEditTime: 2020-12-21 10:40:13
 *  LastEditors: DL
 *  Description: 路线搜索
 *  Copyright: Copyright 2014 - 2020, FengMap, Ltd. All rights reserved.
 */

import React, { useCallback, useState } from 'react';
import { connect } from 'dva';
import router from 'umi/router';
import { Button, Icon, Alert } from 'ui';
import SearchNavigation from '@/components/SearchNavigation';
import Shortcut from '@/components/Shortcut';
import History from '@/components/History';
import FmapProvider from '@/components/FmapProvider';
import { isEmpty } from 'utils/tools';
import styles from './index.less';

function Route(props) {
    const { dispatch } = props;
    const { fmap, listGroups, focusGroupId } = props;
    const { coords, current } = props.map;

    const [keyword, setKeyword] = useState('');
    const [field, setField] = useState('start');
    const [visible, setVisible] = useState(false);
    const [message, setMessage] = useState('');
    const [timer, setIimer] = useState(new Date().valueOf());

    const handleBackClick = useCallback(() => router.push('/home'), []);

    const handleChangeInput = useCallback(keyword => setKeyword(keyword), []);

    const handleShortcutClick = useCallback(keyword => setKeyword(keyword), []);

    const hanldeChangeFocus = useCallback(field => setField(field), []);

    const handleLiClick = useCallback(
        focusModel => {
            dispatch({ type: 'map/updateFocusModel', payload: { focusModel: { ...focusModel } } });
            router.push(`/select?field=${field}`);
        },
        [dispatch, field],
    );

    const handleRouteClick = useCallback(() => router.push(`/select?field=${field}`), [field]);

    const handleCurrentClick = useCallback(() => {
        if (isEmpty(current)) {
            setMessage('当前没有我的位置');
            setVisible(true);
        } else {
            if (field === 'end') {
                setMessage('我的位置不能是终点');
                setVisible(true);
            } else {
                dispatch({ type: 'map/updateCoordField', payload: { field, model: { ...current } } });
                setIimer(new Date().valueOf())
            }
        }
    }, [dispatch, current, field]);

    const startDefaultValue = coords.start && coords.start.name;
    const endDefaultValue = coords.end && coords.end.name;

    return (
        <FmapProvider value={{ fmap, listGroups, focusGroupId }}>
            <Alert visible={visible} message={message} onClose={() => setVisible(false)} />
            <div className={styles.wrapper}>
                <div className={styles.panel}>
                    <SearchNavigation key={timer} startDefaultValue={startDefaultValue} endDefaultValue={endDefaultValue} onBackClick={handleBackClick} onInputChange={handleChangeInput} onInputFocus={hanldeChangeFocus} />
                    <div className={styles.point}>
                        <Button onClick={handleRouteClick}>
                            <Icon className="iconmap" />
                            地图选点
                        </Button>
                        <Button onClick={handleCurrentClick}>
                            <Icon className="icondw" />
                            我的位置
                        </Button>
                    </div>
                    <Shortcut collapsible onClick={handleShortcutClick} />
                </div>
                <div className={styles.panel}>
                    <History keyword={keyword} onLiClick={handleLiClick} />
                </div>
            </div>
        </FmapProvider>
    );
}

export default connect(({ map }) => ({ map }))(Route);
